module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/gallery_hover-d65c2bbf316a50ef9f6d1d95212a4b40.svg";